import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useFormState } from 'react-use-form-state';

import { Input, Label, Form, FormGroup, FormFeedback } from 'reactstrap';

import { Button } from '@shoflo/polymer/components/Button/Button';
const CreateFolderForm = ({ items, onSubmit, onCancel }) => {
  const folderTitleRef = useRef();

  useEffect(() => {
    folderTitleRef.current.focus();
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDuplicateName, setIsDuplicateName] = useState(false);

  const [formState, { text }] = useFormState({
    title: '',
    description: '',
  });

  return (
    <div>
      <Form
        data-testid="folderCreateModal"
        onSubmit={(e) => {
          e.preventDefault();
          setIsSubmitting(true);
          onSubmit(formState.values.title, formState.values.description);
        }}
      >
        <FormGroup>
          <Label id="folderTitleLabel" htmlFor="folderTitle">
            Name
          </Label>
          <Input
            data-testid="nameInput"
            id="folderTitle"
            innerRef={folderTitleRef}
            aria-labelledby="folderTitleLabel"
            placeholder="e.g. My Folder"
            {...text({
              name: 'title',
              validate: (t) => {
                const foundItem = items.find(
                  (item) => item.isDirectory && item.name === t,
                );

                if (foundItem) {
                  setIsDuplicateName(true);
                  return false;
                } else {
                  setIsDuplicateName(false);
                }

                return t.length > 1 && t.length < 129;
              },
              validateOnBlur: false,
              touchOnChange: true,
            })}
            invalid={formState.touched.title && !formState.validity.title}
            required
          />
          {isDuplicateName && (
            <FormFeedback>Uh oh! This folder name already exists.</FormFeedback>
          )}
          {!isDuplicateName && (
            <FormFeedback>
              Uh oh! Folder names must be between 2 and 128 characters.
            </FormFeedback>
          )}
        </FormGroup>
        <FormGroup>
          <Label id="folderDescLabel" htmlFor="folderDescription">
            Description
          </Label>
          <Input
            data-testid="descriptionInput"
            id="folderDescription"
            aria-labelledby="folderDescLabel"
            placeholder="e.g. My Description"
            {...text({
              name: 'description',
              validate: () => {
                return true;
              },
              validateOnBlur: false,
              touchOnChange: true,
            })}
            invalid={
              formState.touched.description && !formState.validity.description
            }
          />
          <FormFeedback>Uh oh! BAD BAD BAD.</FormFeedback>
        </FormGroup>

        <div className="float-end modal-footer">
          <Button
            data-testid="createButton"
            color="primary"
            disabled={!formState.validity.title || isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create'}
          </Button>{' '}
          <Button
            data-testid="cancelButton"
            color="secondary"
            variant="outlined"
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
};

CreateFolderForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  items: PropTypes.array,
};

export default CreateFolderForm;
